import { render, staticRenderFns } from "./EditAnnouncementDialog.vue?vue&type=template&id=3074383d&scoped=true&lang=pug&"
import script from "./EditAnnouncementDialog.vue?vue&type=script&lang=ts&"
export * from "./EditAnnouncementDialog.vue?vue&type=script&lang=ts&"
import style0 from "./EditAnnouncementDialog.vue?vue&type=style&index=0&id=3074383d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3074383d",
  null
  
)

export default component.exports